/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgInsurance32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16.93 7a4.75 4.75 0 117.818 3.627v5.587l-3.067-1.535-3.068 1.535v-5.587A4.74 4.74 0 0116.93 7zm4.75-3.25a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5zm-1.567 7.735v2.301l1.568-.784 1.567.784v-2.3a4.74 4.74 0 01-1.567.264c-.55 0-1.077-.093-1.568-.265z'
      />
      <path
        fill='currentColor'
        d='M5.25 6.25H15v1.5H6.75v20.5h16.5V18h1.5v11.75H5.25V6.25z'
      />
      <path
        fill='currentColor'
        d='M13 11.75H9v-1.5h4v1.5zM9 18.25v1.5h12v-1.5H9zM9 22.75v-1.5h12v1.5H9zM9 25.75h4v-1.5H9v1.5z'
      />
    </svg>
  );
}

export default SvgInsurance32;
